import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

export type ImportLicense = {
    name: string,
    version: string,
    license: "MIT" | "Apache-2.0" | "0BSD" | "(OFL-1.1 AND MIT)" | "ISC",
    link: string,
}

@Injectable()
export class LicenseDialogService {
    constructor(private http: HttpClient) { }

    public getLicenses(): ImportLicense[] {
        return [
            {
                "name": "@agm/core",
                "version": "1.0.0",
                "license": "MIT",
                "link": "git+https://github.com/SebastianM/angular-google-maps.git"
            },
            {
                "name": "@agm/snazzy-info-window",
                "version": "1.0.0",
                "license": "MIT",
                "link": "git+https://github.com/SebastianM/angular-google-maps.git"
            },
            {
                "name": "@angular/animations",
                "version": "9.1.13",
                "license": "MIT",
                "link": "git+https://github.com/angular/angular.git"
            },
            {
                "name": "@angular/cdk",
                "version": "8.2.3",
                "license": "MIT",
                "link": "git+https://github.com/angular/components.git"
            },
            {
                "name": "@angular/common",
                "version": "9.1.13",
                "license": "MIT",
                "link": "git+https://github.com/angular/angular.git"
            },
            {
                "name": "@angular/compiler",
                "version": "9.1.13",
                "license": "MIT",
                "link": "git+https://github.com/angular/angular.git"
            },
            {
                "name": "@angular/core",
                "version": "9.1.13",
                "license": "MIT",
                "link": "git+https://github.com/angular/angular.git"
            },
            {
                "name": "@angular/forms",
                "version": "9.1.13",
                "license": "MIT",
                "link": "git+https://github.com/angular/angular.git"
            },
            {
                "name": "@angular/material",
                "version": "8.2.3",
                "license": "MIT",
                "link": "git+https://github.com/angular/components.git"
            },
            {
                "name": "@angular/material-moment-adapter",
                "version": "^8.2.3",
                "license": "MIT",
                "link": "git+https://github.com/angular/components.git"
            },
            {
                "name": "@angular/platform-browser",
                "version": "9.1.13",
                "license": "MIT",
                "link": "git+https://github.com/angular/angular.git"
            },
            {
                "name": "@angular/platform-browser-dynamic",
                "version": "9.1.13",
                "license": "MIT",
                "link": "git+https://github.com/angular/angular.git"
            },
            {
                "name": "@angular/router",
                "version": "9.1.13",
                "license": "MIT",
                "link": "git+https://github.com/angular/angular.git"
            },
            {
                "name": "@zxing/ngx-scanner",
                "version": "1.4.0",
                "license": "MIT",
                "link": "git+https://github.com/zxing-js/ngx-scanner.git"
            },
            {
                "name": "angular-font-awesome",
                "version": "^3.1.2",
                "license": "MIT",
                "link": "git+ssh://git@github.com/baruchvlz/angular-font-awesome.git"
            },
            {
                "name": "cordova-browser",
                "version": "^6.0.0",
                "license": "Apache-2.0",
                "link": "git+https://github.com/apache/cordova-browser.git"
            },
            {
                "name": "cordova-file-cache",
                "version": "1.2.2",
                "license": "MIT",
                "link": "git+ssh://git@github.com/markmarijnissen/cordova-file-cache.git"
            },
            {
                "name": "cordova-ios",
                "version": "^5.0.0",
                "license": "Apache-2.0",
                "link": "git+https://github.com/apache/cordova-ios.git"
            },
            {
                "name": "cordova-plugin-add-swift-support",
                "version": "^2.0.2",
                "license": "Apache-2.0",
                "link": "git+https://github.com/akofman/cordova-plugin-add-swift-support.git"
            },
            {
                "name": "cordova-plugin-badge",
                "version": "^0.8.8",
                "license": "Apache-2.0",
                "link": "git+https://github.com/katzer/cordova-plugin-badge.git"
            },
            {
                "name": "cordova-plugin-brightness",
                "version": "0.2.0",
                "license": "MIT",
                "link": "git+https://github.com/mgcrea/cordova-plugin-brightness.git"
            },
            {
                "name": "cordova-plugin-camera",
                "version": "4.0.3",
                "license": "Apache-2.0",
                "link": "git+https://github.com/apache/cordova-plugin-camera.git"
            },
            {
                "name": "cordova-plugin-device",
                "version": "^2.0.3",
                "license": "Apache-2.0",
                "link": "https://github.com/apache/cordova-plugin-device/issues"
            },
            {
                "name": "cordova-plugin-file",
                "version": "6.0.1",
                "license": "Apache-2.0",
                "link": "git+https://github.com/apache/cordova-plugin-file.git"
            },
            {
                "name": "cordova-plugin-file-transfer",
                "version": "1.7.1",
                "license": "Apache-2.0",
                "link": "git+https://github.com/apache/cordova-plugin-file-transfer.git"
            },
            {
                "name": "cordova-plugin-geolocation",
                "version": "4.0.1",
                "license": "Apache-2.0",
                "link": "git+https://github.com/apache/cordova-plugin-geolocation.git"
            },
            {
                "name": "cordova-plugin-inappbrowser",
                "version": ".\\plugins\\cordova-plugin-inappbrowser",
                "license": "Apache-2.0",
                "link": "n/a"
            },
            {
                "name": "cordova-plugin-local-notification",
                "version": "^0.9.0-beta.3",
                "license": "Apache-2.0",
                "link": "git+https://github.com/katzer/cordova-plugin-local-notifications.git"
            },
            {
                "name": "cordova-plugin-network-information",
                "version": "^2.0.2",
                "license": "Apache-2.0",
                "link": "git+https://github.com/apache/cordova-plugin-network-information.git"
            },
            {
                "name": "cordova-plugin-phone-call",
                "version": "n/a",
                "license": "MIT",
                "link": "n/a"
            },
            {
                "name": "cordova-plugin-qrscanner",
                "version": "^3.0.1",
                "license": "MIT",
                "link": "git+https://github.com/bitpay/cordova-plugin-qrscanner.git"
            },
            {
                "name": "cordova-plugin-splashscreen",
                "version": "5.0.2",
                "license": "Apache-2.0",
                "link": "git+https://github.com/apache/cordova-plugin-splashscreen.git"
            },
            {
                "name": "cordova-plugin-statusbar",
                "version": "2.4.2",
                "license": "Apache-2.0",
                "link": "git+https://github.com/apache/cordova-plugin-statusbar.git"
            },
            {
                "name": "cordova-plugin-whitelist",
                "version": "1.3.3",
                "license": "Apache-2.0",
                "link": "git+https://github.com/apache/cordova-plugin-whitelist.git"
            },
            {
                "name": "cordova-plugin-wkwebview-engine",
                "version": "^1.2.1",
                "license": "Apache-2.0",
                "link": "git+https://github.com/apache/cordova-plugin-wkwebview-engine.git"
            },
            {
                "name": "cordova-plugin-wkwebviewxhrfix",
                "version": "^0.1.0",
                "license": "MIT",
                "link": "git+https://github.com/themattray/cordova-plugin-wkwebviewxhrfix.git"
            },
            {
                "name": "cordova-promise-fs",
                "version": "1.2.5",
                "license": "MIT",
                "link": "git+ssh://git@github.com/markmarijnissen/cordova-promise-fs.git"
            },
            {
                "name": "cordova.plugins.diagnostic",
                "version": "^5.0.2",
                "license": "MIT",
                "link": "git+https://github.com/dpa99c/cordova-diagnostic-plugin.git"
            },
            {
                "name": "core-js",
                "version": "2.5.0",
                "license": "MIT",
                "link": "git+https://github.com/zloirock/core-js.git"
            },
            {
                "name": "fingerprintjs2",
                "version": "1.5.1",
                "license": "MIT",
                "link": "git+https://github.com/Valve/fingerprintjs2.git"
            },
            {
                "name": "font-awesome",
                "version": "4.7.0",
                "license": "(OFL-1.1 AND MIT)",
                "link": "git+https://github.com/FortAwesome/Font-Awesome.git"
            },
            {
                "name": "hammerjs",
                "version": "2.0.8",
                "license": "MIT",
                "link": "git://github.com/hammerjs/hammer.js.git"
            },
            {
                "name": "howler",
                "version": "2.0.5",
                "license": "MIT",
                "link": "git://github.com/goldfire/howler.js.git"
            },
            {
                "name": "jquery",
                "version": "3.7.1",
                "license": "MIT",
                "link": "git+https://github.com/jquery/jquery.git"
            },
            {
                "name": "linqts",
                "version": "1.10.0",
                "license": "MIT",
                "link": "git+https://github.com/kutyel/linq.ts.git"
            },
            {
                "name": "lodash",
                "version": "4.17.11",
                "license": "MIT",
                "link": "git+https://github.com/lodash/lodash.git"
            },
            {
                "name": "md5-typescript",
                "version": "1.0.0",
                "license": "ISC",
                "link": "git+https://github.com/Hipparch/Md5-typescript.git"
            },
            {
                "name": "moment",
                "version": "2.24.0",
                "license": "MIT",
                "link": "git+https://github.com/moment/moment.git"
            },
            {
                "name": "ngx-bar-rating",
                "version": "1.1.0",
                "license": "MIT",
                "link": "git+ssh://git@github.com/MurhafSousli/ngx-bar-rating.git"
            },
            {
                "name": "ngx-loading",
                "version": "8.0.0",
                "license": "MIT",
                "link": "git+https://github.com/Zak-C/ngx-loading.git"
            },
            {
                "name": "ngx-moment",
                "version": "3.3.0",
                "license": "MIT",
                "link": "git+https://github.com/urish/ngx-moment.git"
            },
            {
                "name": "ngx-swiper-wrapper",
                "version": "7.2.1",
                "license": "MIT",
                "link": "git+https://github.com/zefoy/ngx-swiper-wrapper.git"
            },
            {
                "name": "promise-polyfill",
                "version": "8.1.0",
                "license": "MIT",
                "link": "git+https://github.com/taylorhakes/promise-polyfill.git"
            },
            {
                "name": "signalr",
                "version": "2.4.3",
                "license": "Apache-2.0",
                "link": "git+https://github.com/signalr/signalr.git"
            },
            {
                "name": "smoothscroll-polyfill",
                "version": "^0.4.4",
                "license": "MIT",
                "link": "git+https://github.com/iamdustan/smoothscroll.git"
            },
            {
                "name": "snazzy-info-window",
                "version": "1.1.0",
                "license": "MIT",
                "link": "git+https://github.com/atmist/snazzy-info-window.git"
            },
            {
                "name": "tslib",
                "version": "^1.9.0",
                "license": "0BSD",
                "link": "git+https://github.com/Microsoft/tslib.git"
            },
            {
                "name": "zone.js",
                "version": "~0.10.3",
                "license": "MIT",
                "link": "git://github.com/angular/angular.git"
            }
        ];
    }
}